const fr = {
    '例子': 'Exemples',
}
export default fr;